import type { Messages } from './en';

/** Contingut de la fase 3: minijocs de la sala recreativa (tots de disseny propi). */
export const caArcade: Pick<Messages, 'arcade'> = {
  arcade: {
    title: '🕹️ Sala recreativa',
    hint: 'Tria un joc! Les bones puntuacions donen estrelles (unes quantes per joc cada dia).',
    play: '▶ Jugar',
    again: '🔁 Tornar a jugar',
    back: '⬅ Jocs',
    score: 'Punts',
    best: 'Rècord',
    over: 'Fi de la partida!',
    win: 'Has guanyat!',
    earned: (n: number) => `+${n}⭐ guanyades`,
    capped: 'Avui ja has guanyat les estrelles d’aquest joc. Juga per divertir-te!',
    tap: 'Toca per començar',
    games: {
      volleyball: { name: 'Vòlei sense parar', how: 'Mou-te ◀ ▶ sota la pilota i prem ● per passar-la per sobre la xarxa. Que no caigui!' },
      tennis: { name: 'Raquetada', how: 'Mou-te ◀ ▶ cap a la pilota i prem ● quan t’arribi per tornar-la.' },
      rhythm: { name: 'Piano Marxós', how: 'Toca el carril quan una nota arribi a la línia. Cada encert fa sonar una nota!' },
      drawing: { name: 'Bloc de dibuix', how: 'Dibuixa amb el dit. Tria colors i pinzells, i després comparteix-ho a PixelBook!' },
      racing: { name: 'Cursa pel carrer', how: 'Gira ◀ ▶ per esquivar el trànsit i agafar monedes. Cada cop va més ràpid!' },
      circus: { name: 'Malabars de circ', how: 'Prem ◀ o ▶ quan una pilota arribi a aquella mà per tornar-la a llançar.' },
      minesweeper: { name: 'Hort de talps', how: 'Toca per cavar. Els números diuen quants talps amagats hi ha a prop. Fes servir el mode 🚩 per marcar-los.' },
      snake: { name: 'L’eruga golafre', how: 'Mou-te amb les fletxes o lliscant el dit. Menja fulles per créixer, i no et mosseguis!' },
      baseball: { name: 'Festival de cops de bat', how: 'Prem ● per colpejar quan la pilota arribi a la base. Al moment just, home run!' },
      maze: { name: 'Jardí de lluernes', how: 'Vola pel laberint de bardisses recollint llum. Les flors que brillen fan dormir les granotes!' },
      match3: { name: 'Canvia la fruita', how: 'Intercanvia dues fruites veïnes per posar-ne 3 o més en fila. Tens 25 moviments!' },
      puzzle: { name: 'Trencaclosques lliscant', how: 'Posa les fitxes en ordre de l’1 al 8.' },
      blocks: { name: 'Pila de blocs', how: 'Fes desaparèixer línies amb els blocs que cauen.' },
      goldfish: { name: 'Pesca de Peixos', how: 'Posa la xarxa de paper sota un peix i aixeca-la. Amb suavitat o el paper es trenca! Daurat = 3.' },
      ringToss: { name: 'Llançar Anelles', how: 'Apunta amb ◀ ▶, mantén ● (o la pantalla) i deixa anar amb la força justa. 10 anelles!' },
      claw: { name: 'Màquina de Ganxo', how: 'Mou el ganxo ◀ ▶ (o arrossega), prem ● per baixar-lo i porta un peluix a la sortida. 5 partides!' },
      dragonBoat: { name: 'Regata del Drac', how: 'Prem ◀ ▶ alternant, al ritme del tambor, per remar. A la meta, prem ● per agafar la bandera!' },
      stoneStack: { name: 'Torre de Pedres', how: 'Toca per deixar caure la pedra que es gronxa sobre la torre. Mantén l’equilibri i compte amb el vent!' },
    },
    drawing: {
      prompt: 'La idea d’avui:',
      prompts: ['un gat', 'la teva família', 'un cirerer', 'la casa dels teus somnis', 'un dia de pluja', 'el teu millor amic', 'un monstre'],
      clear: '🗑️',
      eraser: '🧽',
      share: '📤 Compartir a PixelBook',
      shared: 'Compartit! Als teus amics els encanta.',
    },
    mines: { dig: '⛏️ Cavar', flag: '🚩 Bandera', left: (n: number) => `🐹 en queden ${n}` },
  },
};
